import React, { useEffect, useState } from "react";
import BalanceCard from "../BalanceCard/BalanceCard";
import API from "../../services";
import { UserDetails } from "../../models/UserDetails";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../store/store";
import Dialog from "@mui/material/Dialog";
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
import BonusPage from "../BonusPage/BonusPage";
import { getRefId, getDynamicTextColors } from "../../store/authActions";
import { SiteConfig } from "../../models/SiteConfig";
import { useTranslation } from "../../hooks/useTranslation";
import SpinTab from "./SpinTab";

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
}

interface WalletConnectProps {
  userDetails: UserDetails;
  Browser: string;
  siteConfig: SiteConfig;
}

const WalletConnect: React.FC<WalletConnectProps> = ({ userDetails, Browser, siteConfig }) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<any>();
  const [testopen, setTestopen] = useState<any>(false);
  const location = useLocation();
  const { tId, tab } = location.state || {};
  const [activeTab, setActiveTab] = useState<string>("Wallet");
  const inputBoxClass =
    "px-4 py-3 mt-1.5 w-full text-sm font-medium text-white placeholder:text-text-color rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]";
  const dispatch = useDispatch();
  
  // Get dynamic text color classes based on different backgrounds
  const { tabTextColorClass, activeTabTextColorClass } = getDynamicTextColors(userDetails);

  const requestUserContact = () => {

    try {


      window?.Telegram?.WebApp?.ready();

      window?.Telegram?.WebApp?.requestContact((contact) => {
        if (contact) {
          console.log("Contact received:", contact);
          dispatch(getRefId() as any);
        } else {
          console.log("User declined to share contact.");
        }
      });

    } catch (e) {
      console.log("xc", e)
    }
  }

  useEffect(() => {
    // Initialize the Telegram Web App
    if (window?.Telegram?.WebApp) {
      window?.Telegram.WebApp?.ready();

      // Listen for Web App Query results
      window?.Telegram?.WebApp?.onEvent("web_app_query_result", (result) => {
        console.log("Received query result:", result);

        if (result?.ok) {
          // Process the result received from the bot
          const responseData = JSON.parse(result?.result);
          alert(`${t("wallet.messages.success")} ${responseData?.message}`);
        } else {
          // Handle any error in the query response
          console.error("Error in query result:", result?.error);
          alert(t("wallet.messages.anErrorOccurred") + " " + result?.error_message);
        }
      });
    }
  }, []);

  const dummyApi = async (dum: any) => {

    let response: any;
    try {
      response = await API.post(`/debug/debug-info`, {
        info: dum
      });

      console.log("resp", response.data)
    } catch (e) {
      return;
    }


  };

  useEffect(() => {
    const normalizedTab = String(tab || "").toLowerCase();

    if (normalizedTab === "wallet") {
      handleTabClick("Wallet");
      return;
    }

    if (normalizedTab === "spin") {
      handleTabClick("Spin");
      return;
    }

    if (normalizedTab === "bonus" || tId) {
      handleTabClick("Bonus");
    }
  }, [tId, tab]);

  // Switch to Wallet tab if Bonus tab is blocked
  useEffect(() => {
    if (siteConfig?.blockBonus && activeTab === "Bonus") {
      setActiveTab("Wallet");
    }
  }, [siteConfig?.blockBonus, activeTab]);

  const handleSubmit = () => {
    if (!amount || isNaN(amount)) {
      alert(t("wallet.messages.pleaseEnterValidAmount"));
      return;
    }

    // Prepare the query data
    const queryData = {
      action: "deposit",
      amount: parseFloat(amount),
    };

    // Send the query to the bot
    if (window.Telegram?.WebApp) {
      console.log("queryData", queryData)
      window.Telegram.WebApp.sendData(JSON.stringify(queryData));
    } else {
      alert(t("wallet.messages.telegramWebAppNotInitialized"));
    }
  };

  const handleTabClick = (tab: any) => {
    setActiveTab(tab);
  };

  const tabs = [
    {
      key: "Wallet",
      label: t("wallet.wallet"),
      content: (
        <>
          <div className="flex gap-5 justify-end font-medium">
            {
              (!userDetails?.MobileNumber && Browser === "TG") ? (
                <button
                  onClick={requestUserContact}
                  className="border mt-2 text-white rounded-lg px-[10px]"
                >
                  {t("wallet.shareContact")}
                </button>
              ) : (
                <>
                </>
              )
            }
          </div>
          <div className="mt-3 w-full aspect-[2.86]">
            <BalanceCard />
          </div>

          {
            testopen && (
              <Dialog
                fullScreen={false}
                open={testopen}
                onClose={() => setTestopen(false)}
                PaperProps={{
                  style: {
                    position: 'absolute',
                    top: '2rem'
                  }
                }}
              >
                <div className="withdrawdialog-bg bg-inputbox-color relative p-4">
                  <CloseIcon
                    className="absolute top-3 right-3 text-white text-2xl font-semibold"
                    onClick={() => setTestopen(false)}
                  />
                  <div>
                    <div>
                      {t("wallet.enterYourAmount")}
                    </div>
                    <div>
                      <>
                        <label htmlFor="amount" className="block mt-3 text-sm text-zinc-400">
                          {t("common.amount")}
                        </label>
                        <input
                          type="number"
                          id="amount"
                          className={`${inputBoxClass} ${(!userDetails?.MobileNumber && !userDetails?.IsContactOptional) ? "bg-gray-100 cursor-not-allowed" : ""
                            }`}
                          placeholder={t("wallet.enterYourAmount")}
                          value={amount}
                          onChange={(e) => {
                            const value = e.target.value === "" ? 0 : parseFloat(e.target.value);
                            setAmount(value);
                          }}
                          disabled={!userDetails?.MobileNumber && !userDetails?.IsContactOptional}
                        />

                        <button
                          type="submit"
                          className={`p-2.5 mt-4 w-full text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]
                        }`}
                          onClick={() => handleSubmit()}
                        >
                          {t("common.submit")}
                        </button>
                      </>
                    </div>
                  </div>
                </div>
              </Dialog>
            )
          }
        </>
      )
    },
    // Only include Bonus tab if blockBonus is false
    ...(siteConfig?.blockBonus ? [] : [{
      key: "Bonus",
      label: t("wallet.bonus"),
      content: (
        <>
          <BonusPage />
        </>
      )
    }]),
    {
      key: "Spin",
      label: "Spin",
      content: (
        <>
          <SpinTab userDetails={userDetails} />
        </>
      )
    },
  ];

  return (
    <>
      <div className="flex flex-col mt-4 px-4 w-full pb-[6rem] py-[4rem]">
        <div className="bonus-tabs">
          <div className="bonus-nav">
            <div className="navi navi-pills" role="tablist">
              {tabs.map((tab) => (
                <div
                  className="navi-item"
                  key={tab.key}
                  style={{ width: `${100 / tabs.length}%` }}
                >
                  <a
                    role="tab"
                    className={`navi-link ${activeTab === tab.key ? `active ${activeTabTextColorClass}` : tabTextColorClass}`}
                    onClick={() => handleTabClick(tab.key)}
                  >
                    {tab.label}
                  </a>
                </div>
              ))}
            </div>

            <div className="tab-content">
              {tabs.map((tab) => (
                <div
                  key={tab.key}
                  className={`tab-pane fade ${activeTab === tab.key ? "show active" : ""}`}
                  id={`tabs-tabpane-${tab.key}`}
                  role="tabpanel"
                >
                  {activeTab === tab.key && tab.content}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    Browser: state.userDetails?.Browser,
    siteConfig: state.userDetails?.siteConfig,
  };
};

export default connect(mapStateToProps)(WalletConnect);
